<template>
    <div>
        <b-row>
            <b-col>
                <h5 class="text-secondary">Media</h5>
            </b-col>

            <b-col align="right">
                <b-dropdown size="sm" variant="outline-secondary" toggle-class="text-decoration-none" no-caret>
                    <template #button-content>
                        <b-icon-caret-down></b-icon-caret-down>
                    </template>
                    <b-dropdown-item @click="addMedia('45')">45</b-dropdown-item>
                    <b-dropdown-item @click="addMedia('LP')">LP</b-dropdown-item>
                    <b-dropdown-item @click="addMedia('12')">12</b-dropdown-item>
                    <b-dropdown-item @click="addMedia('78')">78</b-dropdown-item>
                    <b-dropdown-item @click="addMedia('CD')">CD</b-dropdown-item>
                    <b-dropdown-item @click="addMedia('CD Single')">CD Single</b-dropdown-item>
                    <b-dropdown-item @click="addMedia('Cassette')">Cassette</b-dropdown-item>
                    <b-dropdown-item @click="addMedia('Cassette Single')">Cassette Single</b-dropdown-item>
                </b-dropdown>

                <b-button @click="addMedia" variant="outline-secondary" size="sm" tabindex="-1">
                    <b-icon-plus></b-icon-plus>
                </b-button>
            </b-col>
        </b-row>

        <b-row v-if="!component.length" class="mb-3">
            <b-col align="center">
                <b-list-group>
                    <b-list-group-item variant="light">
                        <small><em>No Media</em></small>
                    </b-list-group-item>
                </b-list-group>
            </b-col>
        </b-row>
        <div v-for="(media, index) in component" v-bind:key="index" class="mb-3">
            <b-input-group size="sm">

                <b-input v-model="media.count"
                         type="number"
                         placeholder="#"
                         tabindex="-1"
                         min="1"></b-input>

                <b-form-select :options="sizeOptions"
                               v-model="media.size"
                               :state="media.size && media.size.length ? null : false"
                               @change="sizeChange(media.size, index)"
                               :ref="'size-' + index">
                    <template #first>
                        <b-form-select-option :value="null" disabled>Size</b-form-select-option>
                    </template>
                </b-form-select>

                <b-form-select :options="durationOptions"
                               v-model="media.duration"
                               :state="media.duration && media.duration.length ? null : false"
                               @change="durationChange(media.duration, index)"
                               :ref="'duration-' + index"
                               style="width: 4rem;">
                    <template #first>
                        <b-form-select-option :value="null" disabled>Duration</b-form-select-option>
                    </template>
                </b-form-select>

                <b-form-select :options="speedOptions"
                               v-model="media.speed"
                               :state="media.speed && media.speed.length || (media.duration !== 'CD' || media.duration !== 'Cassette' || media.duration !== 'CD Single' || media.duration !== 'Cassette Single') ? null : false"
                               style="width: 4rem;"
                               @change="speedChange(media.speed, index)"
                               :disabled="media.duration === 'CD' || media.duration === 'CD Single' || media.duration === 'Cassette' || media.duration === 'Cassette Single'">
                    <template #first>
                        <b-form-select-option :value="null" disabled>Speed</b-form-select-option>
                    </template>
                </b-form-select>

                <b-input-group-append>
                    <b-button size="sm" variant="outline-secondary" @click="removeMedia(index)" tabindex="-1">
                        <b-icon-x></b-icon-x>
                    </b-button>
                </b-input-group-append>
            </b-input-group>

            <b-form-tags v-model="media.attributes"
                         size="sm"
                         placeholder=""
                         no-outer-focus
                         separator=","
                         remove-on-delete>
                <template v-slot="{ tags, inputAttrs, inputHandlers, removeTag }">
                    <b-input-group aria-controls="my-custom-tags-list" size="sm">
                        <drop @drop="dropAttribute($event, index)" style="width: 100%">
                        <input
                                v-bind="inputAttrs"
                                v-on="inputHandlers"
                                placeholder="Attributes - Enter to add"
                                class="form-control drop-input">
                        </drop>
                    </b-input-group>
                    <ul
                            id="my-custom-tags-list"
                            class="list-unstyled d-inline-flex flex-wrap mb-0"
                            aria-live="polite"
                            aria-atomic="false"
                            aria-relevant="additions removals">
                        <!-- Always use the tag value as the :key, not the index! -->
                        <!-- Otherwise screen readers will not read the tag
                             additions and removals correctly -->
                        <b-card v-for="tag in tags" :key="tag" size="sm"
                                class="mt-1 mr-1"
                                body-class="py-0 pr-2">
                            <span>{{ tag }}</span>
                                <b-button variant="link" class="pt-1 pb-1 text-secondary" @click="removeTag(tag)" tabindex="-1">
                                    <b-icon-x-square></b-icon-x-square>
                                </b-button>
                        </b-card>
                    </ul>
                </template>
            </b-form-tags>
        </div>
    </div>
</template>

<script>
    import arrayMixin from "../../mixins/array";

    export default {
        name: "MediaList",
        props: [ 'media' ],
        mixins: [ arrayMixin ],
        created() {
            this.clone(this.media);
        },
        data() {
            return {
                emptyMedia: {
                    count: 1,
                    size: null,
                    duration: null,
                    speed: null,
                    attributes: [],
                },
                sizeOptions: [
                    { text: '4"', value: '4' },
                    { text: '5"', value: '5' },
                    { text: '7"', value: '7' },
                    { text: '10"', value: '10' },
                    { text: '12"', value: '12' },
                ],
                durationOptions: [
                    {text: 'LP', value: 'LP'},
                    {text: 'EP', value: 'EP'},
                    {text: 'Single', value: 'Single'},
                    {text: 'CD', value: 'CD'},
                    {text: 'CD Single', value: 'CD Single'},
                    {text: 'Cassette', value: 'Cassette'},
                    {text: 'Cass Single', value: 'Cassette Single'},
                ],
                speedOptions: [
                    { text: '33rpm', value: '33' },
                    { text: '45rpm', value: '45' },
                    { text: '78rpm', value: '78' },
                ],
            }
        },
        methods: {
            addMedia(type) {
                if (type === '45') {
                    this.component.push({
                        count: 1,
                        size: "7",
                        duration: "Single",
                        speed: "45",
                        attributes: [],
                    });
                } else if (type === 'LP') {
                    this.component.push({
                        count: 1,
                        size: "12",
                        duration: "LP",
                        speed: "33",
                        attributes: [],
                    });
                } else if (type === '12') {
                    this.component.push({
                        count: 1,
                        size: "12",
                        duration: "Single",
                        speed: "33",
                        attributes: [],
                    });
                } else if (type === '78') {
                    this.component.push({
                        count: 1,
                        size: "10",
                        duration: "Single",
                        speed: "78",
                        attributes: [],
                    });
                } else if (type === 'CD' || type === 'CD Single') {
                    this.component.push({
                        count: 1,
                        size: "5",
                        duration: type,
                        speed: null,
                        attributes: [],
                    });
                } else if (type === 'Cassette' || type === 'Cassette Single') {
                    this.component.push({
                        count: 1,
                        size: "4",
                        duration: type,
                        speed: null,
                        attributes: [],
                    });
                } else {
                    this.component.push(this.emptyMedia);

                    this.$nextTick(() => {
                        let ref = 'size-' + (this.component.length - 1);

                        this.$refs[ref][0].$el.focus();
                    });
                }
            },
            removeMedia(index) {
                this.component.splice(index, 1);
            },
            dropAttribute(note, index) {
                this.component[index].attributes.push(note);
                this.handleNoteDrop(note);
            },
            handleNoteDrop(note) {
                this.$emit('dropNote', note);
            },
            sizeChange(newSize, index) {
                if (newSize === '12' && !this.component[index].duration) {
                    this.component[index].speed = '33';
                    this.component[index].duration = 'LP';
                }

                if (newSize === '7') {
                    this.component[index].speed = '45';
                    this.component[index].duration = 'Single';
                }

                if (newSize === '5') {
                    this.component[index].speed = null;
                    this.component[index].duration = 'CD';
                }

                if (newSize === '4') {
                    this.component[index].speed = null;
                    this.component[index].duration = 'Cassette';
                }
            },
            durationChange(newDuration, index) {
                if (newDuration === 'CD' || newDuration === 'CD Single') {
                    this.component[index].speed = null;
                } else if (newDuration === 'Cassette' || newDuration === 'Cassette Single') {
                    this.component[index].speed = null;
                }
            },
            speedChange(newSpeed, index) {
                console.log('MediaList speedChange called with:', { newSpeed, index });
                this.$emit('updateSpeed', newSpeed);
                
                if (newSpeed === '78') {
                    this.component[index].duration = 'Single';
                    // this.component[index].size = '10';
                }
            },
        },
        watch: {
            component: {
                deep: true,
                handler(newVal) {
                    this.$emit('update', newVal);
                }
            }
        }
    }
</script>

<style scoped>
    .custom-select.is-invalid {
        background: none;
    }

    .drop-input {
        height: calc(1.5em + 0.5rem + 2px);
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
    }
</style>